var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.00024C0 2.23882 2.23858 0.000244141 5 0.000244141H27C29.7614 0.000244141 32 2.23882 32 5.00024V27.0002C32 29.7617 29.7614 32.0002 27 32.0002H5C2.23858 32.0002 0 29.7617 0 27.0002V5.00024ZM16 8.00024C20.4 8.00024 24 11.6002 24 16.0002C24 20.0002 21.1 23.4002 17.1 24.0002V18.3002H19L19.4 16.0002H17.2V14.5002C17.2 13.9002 17.5 13.3002 18.5 13.3002H19.5V11.3002C19.5 11.3002 18.6 11.1002 17.7 11.1002C15.9 11.1002 14.7 12.2002 14.7 14.2002V16.0002H12.7V18.3002H14.7V23.9002C10.9 23.3002 8 20.0002 8 16.0002C8 11.6002 11.6 8.00024 16 8.00024Z",
    fill: "#E2E2E2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d5449edbde8d2b8f56f469e38ff003a1.svg";
export { ForwardRef as ReactComponent };